export default function MarketplaceSkeleton() {
  return (
    <div className="min-h-screen bg-background">
      {/* Search bar skeleton */}
      <div className="mx-auto max-w-7xl px-4 py-8">
        <div className="h-12 w-full bg-surface-2 rounded-lg animate-pulse" />
      </div>
      
      {/* Filters skeleton */}
      <div className="mx-auto max-w-7xl px-4 flex gap-4 mb-8">
        <div className="h-10 w-32 bg-surface-2 rounded-lg animate-pulse" />
        <div className="h-10 w-32 bg-surface-2 rounded-lg animate-pulse" />
        <div className="h-10 w-32 bg-surface-2 rounded-lg animate-pulse" />
      </div>
      
      {/* Agent cards skeleton */}
      <div className="mx-auto max-w-7xl px-4 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {[1, 2, 3, 4, 5, 6, 7, 8].map((i) => (
          <div key={i} className="rounded-2xl bg-surface-1 border border-border/50 overflow-hidden">
            <div className="h-48 w-full bg-surface-2 animate-pulse" />
            <div className="p-4 space-y-2">
              <div className="h-5 w-3/4 bg-surface-2 rounded-lg animate-pulse" />
              <div className="h-4 w-1/2 bg-surface-2 rounded-lg animate-pulse" />
              <div className="flex justify-between items-center mt-4">
                <div className="h-6 w-20 bg-surface-2 rounded-lg animate-pulse" />
                <div className="h-8 w-24 bg-brand-glow/20 rounded-lg animate-pulse" />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
